export default function setTime(date, time = '00:00:00') {
  date = new Date(date);
  const [hours, minutes, seconds] = time.split(':');
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(seconds);
  return date;
}
